__turbopack_context__.v({
  "accountDropdown": "AccountDropdown-module__2ie3Jq__accountDropdown",
  "accountMenuItem": "AccountDropdown-module__2ie3Jq__accountMenuItem",
  "trigger": "AccountDropdown-module__2ie3Jq__trigger",
  "triggerActive": "AccountDropdown-module__2ie3Jq__triggerActive",
});
